import { Lock, Star, Download, ShieldCheck, Users, Heart } from "lucide-react";
import { useLang } from "@/context/LangContext";

const BADGES_FR = [
  { icon: Lock, title: "Paiement sécurisé", sub: "Stripe · cartes cryptées" },
  { icon: Star, title: "+ de 400 avis", sub: "communauté vérifiée" },
  { icon: Download, title: "Téléchargement instantané", sub: "ebooks PDF haute qualité" },
  { icon: ShieldCheck, title: "Satisfait ou remboursé", sub: "sous 30 jours" },
];

const BADGES_EN = [
  { icon: Lock, title: "Secure payment", sub: "Stripe · encrypted cards" },
  { icon: Star, title: "400+ reviews", sub: "verified community" },
  { icon: Download, title: "Instant download", sub: "high-quality PDF ebooks" },
  { icon: ShieldCheck, title: "Money-back guarantee", sub: "within 30 days" },
];

export default function TrustBadges({ variant = "row" }) {
  const { lang } = useLang();
  const items = lang === "fr" ? BADGES_FR : BADGES_EN;

  if (variant === "compact") {
    return (
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-[color:var(--ink-2)]" data-testid="trust-badges-compact">
        {items.slice(0, 3).map((b) => {
          const I = b.icon;
          return (
            <span key={b.title} className="inline-flex items-center gap-1.5">
              <I size={13} className="text-[color:var(--palm)]" />
              <span className="font-medium">{b.title}</span>
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <section data-testid="trust-badges" className="border-y border-[color:rgba(0,16,48,0.08)] bg-[var(--bg-2)]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map((b) => {
          const I = b.icon;
          return (
            <div key={b.title} className="flex items-center gap-4">
              <div className="w-11 h-11 rounded-full bg-[var(--bg)] border border-[color:rgba(0,16,48,0.12)] flex items-center justify-center flex-shrink-0">
                <I size={18} className="text-[color:var(--navy)]" strokeWidth={1.8} />
              </div>
              <div className="min-w-0">
                <p className="font-medium text-sm leading-tight">{b.title}</p>
                <p className="text-xs text-[color:var(--ink-3)] leading-tight mt-0.5">{b.sub}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
